export const config = {
  MODE: process.env.MODE,
  BASE_ROUTE_PATH: process.env.VITE_BASE_PATH || '',
  SENTRY_URL: process.env.VITE_SENTRY_URL,
} as const;
